
// export const base_path = "/";
// export const img_path = "/";

// export const COMPANY_LOCATION = "Next to Karama Post Office,Dubai";
// export const COMPANY_PHONE_NUMBER = "+(971) 4342-6666";
// export const COMPANY_MAIL = "info@example.com";
// export const COMPANY_NAME = "Emirates Secretarial Services";

// ll


export const base_path = "/";
export const img_path = "/";

export const COMPANY_LOCATION = "Next to Karama Post Office,Dubai";
export const COMPANY_PHONE_NUMBER = "+(971) 4342-6666";
export const COMPANY_MAIL = "info@example.com";
export const COMPANY_NAME = "Emirates Secretarial Services";



export const PUBLIC_API_URL = "https://kbc.center/api/";

export const SIGNALR_HUB_URL = "https://kbc.center/notificationHub";

export const IMAGE_SERVER_PATH = "https://kbc.center";

